/* Mini cross-sell (snippets/buy-box-crosssell.liquid)
   One-tap "Add" pill in the product buy box. Adds a single unit of the
   merchant-picked variant via the Cart AJAX API, then repaints the cart
   drawer through the Section Rendering API — the same plumbing as
   assets/cart-cro-add.js (fetchConfig / routes / publish / PUB_SUB_EVENTS +
   <cart-drawer>.getSectionsToRender()/renderContents()). */
(function () {
  'use strict';

  if (customElements.get('buy-box-crosssell')) return;

  function requestConfig() {
    if (typeof window.fetchConfig === 'function') return window.fetchConfig();
    return {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    };
  }

  function addRoute() {
    var routes = window.routes || {};
    return routes.cart_add_url || '/cart/add';
  }

  // The cart drawer is the primary paint target; cart-notification exposes the
  // same getSectionsToRender()/renderContents() contract when the merchant
  // uses the notification cart type instead.
  function findCart() {
    return document.querySelector('cart-drawer') || document.querySelector('cart-notification');
  }

  function sectionIdsFor(cart) {
    if (!cart || typeof cart.getSectionsToRender !== 'function') return [];
    return cart.getSectionsToRender().map(function (section) {
      return section.id;
    });
  }

  function postJSON(url, payload) {
    var config = requestConfig();
    config.body = JSON.stringify(payload);
    return fetch(url, config).then(function (response) {
      return response.json().then(function (body) {
        if (!response.ok || !body || body.status || body.errors) {
          throw new Error('cart-request-failed');
        }
        return body;
      });
    });
  }

  function paintCart(cart, state) {
    if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
      window.publish(window.PUB_SUB_EVENTS.cartUpdate, {
        source: 'buy-box-crosssell',
        cartData: state,
      });
    }

    if (cart && typeof cart.renderContents === 'function' && state && state.sections) {
      cart.renderContents(state);
    }
  }

  function showError(host, message) {
    var errorElement = host.querySelector('[data-cro-error]');
    if (errorElement) errorElement.textContent = message;
  }

  function setBusy(button, isBusy) {
    if (!button) return;
    button.toggleAttribute('disabled', isBusy);
    button.classList.toggle('is-loading', isBusy);
    button.setAttribute('aria-busy', isBusy ? 'true' : 'false');
  }

  customElements.define(
    'buy-box-crosssell',
    class BuyBoxCrosssell extends HTMLElement {
      constructor() {
        super();
        this.onClick = this.onClick.bind(this);
      }

      connectedCallback() {
        this.addEventListener('click', this.onClick);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
      }

      onClick(event) {
        var button = event.target.closest('[data-crosssell-add]');
        if (!button || !this.contains(button)) return;

        var variantId = button.dataset.variantId;
        if (!variantId) return;

        event.preventDefault();
        showError(this, '');
        setBusy(button, true);

        var host = this;
        var cart = findCart();
        var errorText = this.dataset.errorText || '';

        postJSON(addRoute(), {
          items: [{ id: variantId, quantity: 1 }],
          sections: sectionIdsFor(cart),
          sections_url: window.location.pathname,
        })
          .then(function (state) {
            setBusy(button, false);
            paintCart(cart, state);
          })
          .catch(function () {
            setBusy(button, false);
            showError(host, errorText);
          });
      }
    }
  );
})();
